import { render, staticRenderFns } from "./recycleModel.vue?vue&type=template&id=29047a23"
import script from "./recycleModel.vue?vue&type=script&lang=js"
export * from "./recycleModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports